import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dynamic from 'next/dynamic';
import { actions as modalActions } from '@gcloud-npm/next12.app-controller.reducers-sagas.modals-reducer';
import TextInfo from '@gcloud-npm/next12.components.text-info-n';
import Button from '@gcloud-npm/next12.components.button-m';
import Image from '@gcloud-npm/next12.components.image-n';
import CustomLink from '@gcloud-npm/next12.components.custom-link';
import Call4Selling from '@/components/call-4-selling-n';

export const COMPONENT_NAME = 'banner-secundario';

const ModalAtencionEmp = dynamic(() =>
  import('@gcloud-npm/next12.components.modal-atencion-emp')
);

const BannerCta = (props) => {
  const { call4SellingProps, imgPosition, bgColor } = props;
  const { data } = useSelector((state) => state.constants);

  const taggingInfo = {
    componentVariation: 'all',
    componentName: COMPONENT_NAME,
    componentProduct: '',
  };

  const dispatch = useDispatch();

  const handleModal = () => {
    const MODAL_PROPS = {
      contentPosition: 'right--center',
      opacityLayoutColor: 'black05',
      inSceneEffect: 'faseInLeft',
      outSceneEffect: 'fadeOutRight',
      closeByClickingOutside: true,
      scrollAllowed: false,
    };
    dispatch(
      modalActions.addModal({
        id: 'atencionModal',
        type: 'MODAL',
        elementProps: {
          tabsOptions: data.modalAtencionConfig,
          product: 'Fondos Europeos Digitalizacion Empresas',
          taggingInfo: {
            componentProduct: 'Fondos Europeos Digitalizacion Empresas',
            componentVariation: 'all',
            componentName: COMPONENT_NAME,
          },
        },
        Element2Show: ModalAtencionEmp,
        modalProps: MODAL_PROPS,
      })
    );
  };

  return (
    <>
      <section className="BannerCtaSection">
        <CustomLink
          isBlockElement
          onClick={
            props['Button-1'].href === 'javascript:void(0)' ? handleModal : null
          }
          href={
            props['Button-1'].href === 'javascript:void(0)'
              ? null
              : props['Button-1'].href
          }
          target={props['Button-1'].target}
          taggingInfo={{
            ...taggingInfo,
            componentContent: 'te-llamamos',
          }}
        >
          <div
            className={`BannerCta imgPosition--${
              imgPosition || 'right'
            } bgColor--${bgColor || 'blue'} container`}
          >
            {props['Image-1'] && props['Image-1'].src && (
              <div className="image">
                <Image
                  src={`${process.env.NEXT_PUBLIC_CDN}/${props['Image-1'].src}`}
                  alt={props['Image-1'].alt}
                  layout="responsive"
                  width={290}
                  height={290}
                />
              </div>
            )}
            <div className="BannerCtaText">
              <div className="title">
                <TextInfo {...props['TextInfo-1']} />
              </div>
              <div className="subtitle">
                <TextInfo {...props['TextInfo-2']} />
              </div>
              {props['Button-1'] && props['Button-1'].label && (
                <div className="button">
                  <Button
                    {...props['Button-1']}
                    taggingInfo={{
                      ...taggingInfo,
                      componentContent: 'te-llamamos',
                    }}
                  />
                  {call4SellingProps && (
                    <div className="call4selling">
                      <Call4Selling
                        {...call4SellingProps}
                        taggingInfo={{
                          ...taggingInfo,
                        }}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </CustomLink>
      </section>
      <style jsx>
        {`
          .BannerCtaSection {
            padding: 2rem 1rem;
            display: flex;
            justify-content: center;
            .bgColor {
              &--blue {
                background-color: var(--color-emp--blue);
              }
              &--grey5 {
                background-color: var(--color-emp--grey5);
              }
            }
            .BannerCta {
              padding: 2rem;
              .BannerCtaText {
                .title {
                  margin-top: 1rem;
                }
                .subtitle {
                  line-height: 1.5rem;
                  margin: 1.5rem 0 2.25rem;
                }
                .button {
                  display: flex;
                  flex-direction: column;
                  .call4selling {
                    margin-top: 1rem;
                    justify-content: center;
                    display: flex;
                  }
                }
              }
            }
          }

          @media screen and (min-width: 769px) {
            .BannerCtaSection {
              height: auto;
              .imgPosition {
                &--right {
                  flex-direction: row-reverse;
                }
                &--left {
                  flex-direction: row;
                }
              }
              .BannerCta {
                display: flex;
                align-items: center;
                justify-content: left;
                .image {
                  width: 20.125rem;
                  margin: auto;
                }
                .BannerCtaText {
                  margin-left: 2rem;
                  margin-right: 5%;
                  margin-bottom: 1.5rem;
                  max-width: 52%;
                  .title {
                    margin-bottom: 1.5rem;
                  }
                  .subtitle {
                    margin-bottom: 4rem;
                  }
                  .button {
                    display: flex;
                    text-align: inherit;
                    flex-direction: row;
                    .call4selling {
                      margin: auto 0 auto 1.5rem;
                    }
                  }
                }
              }
            }
          }
        `}
      </style>
    </>
  );
};

export default BannerCta;
